$(() => {
  const offcanvasNavbar = document.querySelector('#offcanvas-navbar')
  const $navbarToggler = $('.navbar-toggler')
  const $navbar = $('.navbar')
  const $navbarLogo = $('.navbar .navbar-brand img')
  const navbarLogoSrc = $navbarLogo.attr('src').replace('white', 'black');

  offcanvasNavbar.addEventListener('show.bs.offcanvas', () => {
    $navbarToggler.addClass('active')
    $navbar.addClass('show')
    $navbarLogo.attr('src', navbarLogoSrc.replace('black', 'white'))
  })

  offcanvasNavbar.addEventListener('hide.bs.offcanvas', () => {
    $navbarToggler.removeClass('active')
    $navbar.removeClass('show')

    if($('body').hasClass('home')) {
      if(window.scrollY > $('.section-fv__slider video').height() / 2) {
        $navbarLogo.attr('src', navbarLogoSrc)
      }
    }else {
      $navbarLogo.attr('src', navbarLogoSrc)
    }
  })

  $('.list-nav-accordion .nav-accordion-button').on('click', function(e) {
    if(!window.matchMedia('(min-width: 768px)').matches){
      e.preventDefault()
      $this = $(this)

      $this.toggleClass('active').next('.nav-list-child').slideToggle()
    }
  })

  if($('body').hasClass('home')) {
    $(window).on('load scroll', () => {
      if(window.scrollY > $('.section-fv__slider video').height() / 2) {
        $navbar.removeClass('navbar-top-active')
        $navbarLogo.attr('src', navbarLogoSrc)
      }else {
        $navbar.addClass('navbar-top-active')
        $navbarLogo.attr('src', navbarLogoSrc.replace('black', 'white'))
      }
    })
  }

})